import {FC} from 'react'
import {PageTitle} from '../../../../_metronic/layout/core'

const TariffDetailPage: FC<{subject: string}> = ({subject}) => {
  return <PageTitle breadcrumbs={[]}>Welcome Admin</PageTitle>
}

export default TariffDetailPage
